"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
// import { AxiosResponse } from "axios";
const slice_1 = __importStar(require("./slice"));
const AsyncStorage_1 = __importDefault(require("../../utils/AsyncStorage"));
const constants_1 = __importDefault(require("../../constants/constants"));
const Auth_1 = __importDefault(require("../../networking/apis/Auth"));
function* saveLoginUser(data) {
    AsyncStorage_1.default.set(constants_1.default.ACCESS_TOKEN_LOCAL, data.token);
    AsyncStorage_1.default.set(constants_1.default.REFRESH_TOKEN_LOCAL, data.refreshToken);
}
function* loginHandle(action) {
    const { email, passWord } = action.payload;
    //   try {
    const res = yield Auth_1.default.loginWithFujisan(email, passWord);
    if (res.status == 200) {
        yield (0, effects_1.call)(saveLoginUser, {
            token: res.data.data.token,
            refreshToken: res.data.data.refresh_token,
        });
        yield (0, effects_1.put)((0, slice_1.saveAccessTokenAction)(res.data.data.token));
    }
    yield (0, effects_1.put)((0, slice_1.setProfileAction)({
        name: "田中太郎",
        tagname: "@taro_tanaka_ts",
        follow: 99,
        followers: 999,
    }));
    //     const profile: AxiosResponse = yield getProfile();
    //     const dataProfile: ProfileDataProps = profile.data.data;
    //     yield put(setProfileAction(dataProfile));
    //     if (dataProfile.status === Constants.FIRST_SIGN_IN) {
    //       yield put(setLoginStateAction(LoginState.FIRST_SIGN_IN));
    //     } else if (dataProfile.status === Constants.IN_ACTIVE) {
    //       if (appRole === Constants.APP_ROLE_USER) {
    //         yield put(setLoginStateAction(LoginState.SELECT_PLAN));
    //       } else {
    //         yield put(setLoginStateAction(LoginState.IS_UPDATE_INFO));
    //       }
    //     } else {
    //       yield call(saveAppRole, appRole);
    //       yield put(setLoginStateAction(LoginState.IS_LOGGED));
    //     }
    //   } catch (err: any) {
    //     const message = err?.response?.data?.message;
    //     log("err", err, err?.response);
    //     yield put(
    //       setErrorMessageAction(err?.response?.status == 411 ? "" : message)
    //     );
    //   }
}
function* loginSaga() {
    yield (0, effects_1.all)([(0, effects_1.takeLatest)(slice_1.default.actions.login, loginHandle)]);
}
exports.default = loginSaga;
